import TransaksiService from "../../../services/transaksi/TransaksiService"
import UserService from "../../../services/user/UserService"
import MasterService from "../../../services/master/MasterService"
import { pdf } from "@react-pdf/renderer"
import DraftH from "./DraftH"
import DraftA from "./DraftA"
import DraftB from "./DraftB"
import DraftC from "./DraftC"
import DraftD from "./DraftD"
import DraftE from "./DraftE"
import DraftF from "./DraftF"
import DraftG from "./DraftG"
import DraftNZ from "./DraftNZ"
import DraftUK from "./DraftUK"
import DraftXA from "./DraftXA"
import DraftXF from "./DraftXF"

export const generatePdfToBlob = async ({
    datappm,
    noTugas,
    qrImage,
    finalFor = '1'
}) => {
    if (!datappm) {
        throw new Error("datappm kosong");
    }

    const transaksiService = new TransaksiService();
    const userService = new UserService();
    const masterService = new MasterService();

    // fetch semua data
    const jsonMutuPK = {
        nomorAju: datappm.nomorAju,
        noProses: noTugas
    };

    const jsonPelMuat = {
        jnsPelabuhan: "D",
        kodePelabuhan: datappm.pelabuhanMuat
    };

    const jsonPelBongkar = {
        jnsPelabuhan: "L",
        kodePelabuhan: datappm.pelabuhanBongkar
    };

    const [
        resHc,
        resUpt,
        resNeg,
        resPelMuat,
        resPelBongkar,
        resDetil,
        resKemasan,
        resKontainer,
        resMutu,
        resMutuProd,
        resMutuArea,
        resTotal,
        resHasilVerLap
    ] = await Promise.all([
        transaksiService.getHcMutuById(jsonMutuPK),
        userService.getUptById(datappm.kdUpt),
        masterService.getNegaraById(datappm.negaraPartner),
        masterService.getPelabuhanById(JSON.stringify(jsonPelMuat)),
        masterService.getPelabuhanById(JSON.stringify(jsonPelBongkar)),
        transaksiService.listPpmDetilAll(datappm.nomorAju),
        transaksiService.listPpmKemasanAll(datappm.nomorAju),
        transaksiService.listPpmContainerAll(datappm.nomorAju),
        transaksiService.getPpmMutuById(datappm.nomorAju),
        transaksiService.listPpmMutuProdAll(datappm.nomorAju),
        transaksiService.listPpmMutuAreaAll(datappm.nomorAju),
        transaksiService.getTotalJumlahKomoditiPerSatuan(datappm.nomorAju),
        transaksiService.listHasilVerLapangan(0, datappm.nomorAju, 0, 10),
    ]);


    const getData = (res, fallback = []) =>
        res?.data?.data ?? res?.data ?? fallback;

    const dataHc = getData(resHc);
    const upt = getData(resUpt, {});
    const negaraTujuan = getData(resNeg, {});
    const pelMuat = getData(resPelMuat, {});
    const pelBongkar = getData(resPelBongkar, {});
    const ppmDetil = getData(resDetil);
    const ppmKemasan = getData(resKemasan);
    const ppmKontainer = getData(resKontainer);
    const ppmMutu = getData(resMutu, {});
    const ppmMutuProd = getData(resMutuProd);
    const ppmMutuArea = getData(resMutuArea);
    const totalJumlah = getData(resTotal);
    const hasilVerLap = getData(resHasilVerLap);

    const ppmKemasanBaru = await Promise.all(
        ppmKemasan.map(async (kms) => {
            try {
                const res = await masterService.getKemasanById(kms.kodeKemasan);
                return {
                    ...kms,
                    uraianKemasan: res.data?.uraianKemasan ?? "-"
                };
            } catch (err) {
                console.error(err);
                return {
                    ...kms,
                    uraianKemasan: "-"
                };
            }
        })
    )

    const resSpesimenTtdH = async () => {
        try {
            let res = await userService.getPegawaiById(dataHc?.nipPejabat)
            return res?.data?.pathTtdImg
        } catch (error) {

        }
    }
    const spesimenTtdH = resSpesimenTtdH()

    let toBlob;
    try {
        if (datappm?.peruntukan === '2') {
            toBlob = await pdf(<DraftH datappm={datappm}
                dataHc={dataHc}
                ppmDetil={ppmDetil}
                ppmKontainer={ppmKontainer}
                ppmKemasan={ppmKemasanBaru}
                ppmMutu={ppmMutu}
                ppmMutuArea={ppmMutuArea}
                ppmMutuProd={ppmMutuProd}
                upt={upt}
                negaraTujuan={negaraTujuan}
                pelMuat={pelMuat}
                pelBongkar={pelBongkar}
                qrImage={qrImage}
                spesimenTtd={spesimenTtdH}
                finalFor={finalFor}
            />).toBlob()
        } else {
            switch (negaraTujuan?.kdHcm) {
                case 'H':
                    toBlob = await pdf(
                        <DraftH
                            datappm={datappm}
                            dataHc={dataHc}
                            ppmDetil={ppmDetil}
                            ppmKontainer={ppmKontainer}
                            ppmKemasan={ppmKemasanBaru}
                            ppmMutu={ppmMutu}
                            ppmMutuArea={ppmMutuArea}
                            ppmMutuProd={ppmMutuProd}
                            upt={upt}
                            negaraTujuan={negaraTujuan}
                            pelMuat={pelMuat}
                            pelBongkar={pelBongkar}
                            qrImage={qrImage}
                            spesimenTtd={spesimenTtdH}
                            finalFor={finalFor}
                        />
                    ).toBlob()
                    break;
                case 'A':
                    toBlob = await pdf(
                        <DraftA
                            datappm={datappm}
                            dataHc={dataHc}
                            ppmDetil={ppmDetil}
                            ppmKontainer={ppmKontainer}
                            ppmKemasan={ppmKemasanBaru}
                            ppmMutu={ppmMutu}
                            ppmMutuProd={ppmMutuProd}
                            upt={upt}
                            negaraTujuan={negaraTujuan}
                            pelMuat={pelMuat}
                            pelBongkar={pelBongkar}
                            totalJumlah={totalJumlah}
                            qrImage={qrImage}
                            spesimenTtd={spesimenTtdH}
                        />
                    ).toBlob()
                    break;
                case 'B':
                    const batasTanggal = '2025-07-01'
                    let isFormLama
                    if (new Date(dataHc?.tglHc) < new Date(batasTanggal)) {
                        isFormLama = true
                    } else {
                        isFormLama = false
                    }

                    const detilIkan = await Promise.all(
                        ppmDetil.map(async (dtl, index) => {
                            let resIdIkan = await masterService.getMasterIkanById(dtl.idIkan)
                            return resIdIkan?.data
                        })
                    )

                    let uraianKota = ''
                    let uraianProp = ''
                    if (ppmMutuArea[0]?.mutuArea !== undefined && ppmMutuArea[0].mutuArea === '1') {
                        const kotaKab = async () => {
                            let resKota = await masterService.getKotaById(ppmMutuArea[0].mutuCultKota)
                            return resKota?.data?.uraianKota ?? '-'
                        }
                        uraianKota = await kotaKab()

                        const prop = async () => {
                            let resProp = await masterService.getPropinsiById(ppmMutuArea[0].mutuCultProp)
                            return resProp?.data?.uraianPropinsi ?? '-'
                        }
                        uraianProp = await prop()
                    }

                    toBlob = await pdf(
                        <DraftB
                            datappm={datappm}
                            ppmDetil={ppmDetil}
                            ppmKontainer={ppmKontainer}
                            ppmKemasan={ppmKemasanBaru}
                            ppmMutu={ppmMutu}
                            ppmMutuProd={ppmMutuProd}
                            ppmMutuArea={ppmMutuArea}
                            dataHc={dataHc}
                            upt={upt}
                            negaraTujuan={negaraTujuan}
                            pelMuat={pelMuat}
                            pelBongkar={pelBongkar}
                            totalJumlah={totalJumlah}
                            detilIkan={detilIkan[0]}
                            isFormLama={isFormLama}
                            qrImage={qrImage}
                            uraianKota={uraianKota}
                            uraianProp={uraianProp}
                            spesimenTtd={spesimenTtdH}
                        />
                    ).toBlob()
                    break;
                case 'C':
                    toBlob = await pdf(
                        <DraftC
                            datappm={datappm}
                            ppmDetil={ppmDetil}
                            ppmKontainer={ppmKontainer}
                            ppmKemasan={ppmKemasanBaru}
                            ppmMutu={ppmMutu}
                            ppmMutuProd={ppmMutuProd}
                            ppmMutuArea={ppmMutuArea}
                            dataHc={dataHc}
                            upt={upt}
                            pelBongkar={pelBongkar}
                            totalJumlah={totalJumlah}
                            qrImage={qrImage}
                            spesimenTtd={spesimenTtdH}
                        />
                    ).toBlob()
                    break;
                case 'D':
                    const resNoDok = async () => {
                        try {
                            let res = await transaksiService.getPpmDokByAjuKodeDok(datappm.nomorAju, '705')
                            if (res?.data) {
                                return res?.data?.nomor
                            } else {
                                res = await transaksiService.getPpmDokByAjuKodeDok(datappm.nomorAju, '704')
                                return res?.data?.nomor
                            }
                        } catch (error) {
                        }
                    }
                    let nomorDokumen = await resNoDok()
                    toBlob = await pdf(
                        <DraftD
                            datappm={datappm}
                            ppmDetil={ppmDetil}
                            ppmKontainer={ppmKontainer}
                            ppmKemasan={ppmKemasanBaru}
                            ppmMutu={ppmMutu}
                            ppmMutuProd={ppmMutuProd}
                            dataHc={dataHc}
                            upt={upt}
                            negaraTujuan={negaraTujuan}
                            pelMuat={pelMuat}
                            pelBongkar={pelBongkar}
                            nomorDokumen={nomorDokumen}
                            qrImage={qrImage}
                            spesimenTtd={spesimenTtdH}
                        />
                    ).toBlob()
                    break;
                case 'E':
                    toBlob = await pdf(
                        <DraftE
                            datappm={datappm}
                            ppmDetil={ppmDetil}
                            ppmKontainer={ppmKontainer}
                            ppmKemasan={ppmKemasanBaru}
                            ppmMutu={ppmMutu}
                            ppmMutuProd={ppmMutuProd}
                            dataHc={dataHc}
                            upt={upt}
                            negaraTujuan={negaraTujuan}
                            pelMuat={pelMuat}
                            pelBongkar={pelBongkar}
                            qrImage={qrImage}
                            spesimenTtd={spesimenTtdH}
                        />
                    ).toBlob()
                    break;
                case 'F':
                    const ppmMutuAreaBaru = await Promise.all(
                        ppmMutuArea.map(async (area) => {
                            try {
                                let resKota
                                let resPropEn
                                if (area.mutuArea === '1') {
                                    resKota = await masterService.getKotaById(area.mutuCultKota)
                                    resPropEn = await masterService.getPropinsiById(area.mutuCultProp)
                                }
                                return {
                                    ...area,
                                    uraianKota: resKota.data?.uraianKota ?? "-",
                                    uraianPropinsi: resPropEn.data?.uraianPropinsiEn ?? "-"
                                };
                            } catch (err) {
                                // console.error(err);
                                return {
                                    ...area,
                                    uraianKota: "-",
                                    uraianPropinsi: "-"
                                };
                            }
                        })
                    )

                    const resNoDokumen = async () => {
                        try {
                            let res = await transaksiService.getPpmDokByAjuKodeDok(datappm.nomorAju, '705')
                            if (res?.data) {
                                return res?.data?.nomor
                            } else {
                                res = await transaksiService.getPpmDokByAjuKodeDok(datappm.nomorAju, '704')
                                return res?.data?.nomor
                            }
                        } catch (error) {
                        }
                    }
                    let nomorDokumenBL = await resNoDokumen()

                    const resTgl = async (idJnsDok) => {
                        try {
                            let res = await transaksiService.getPpmDokByAjuKodeDok(datappm.nomorAju, idJnsDok)
                            return res?.data?.tanggal
                        } catch (error) {

                        }
                    }
                    let tglScanning = await resTgl('1018')
                    let tglLhpScanning = await resTgl('1019')

                    const resSpesimenTtd = async () => {
                        try {
                            let res = await userService.getPegawaiById(dataHc?.nipPejabat)
                            return res?.data?.pathTtdImg
                        } catch (error) {

                        }
                    }
                    const spesimenTtd = resSpesimenTtd()

                    toBlob = await pdf(
                        <DraftF
                            datappm={datappm}
                            ppmDetil={ppmDetil}
                            ppmKontainer={ppmKontainer}
                            ppmKemasan={ppmKemasanBaru}
                            ppmMutu={ppmMutu}
                            ppmMutuArea={ppmMutuAreaBaru}
                            ppmMutuProd={ppmMutuProd}
                            dataHc={dataHc}
                            upt={upt}
                            pelMuat={pelMuat}
                            pelBongkar={pelBongkar}
                            totalJumlah={totalJumlah}
                            hasilVerLap={hasilVerLap[0]}
                            nomorDokumen={nomorDokumenBL}
                            tanggalScanning={tglScanning}
                            tanggalLhpScanning={tglLhpScanning}
                            spesimenTtd={spesimenTtd}
                            finalFor={finalFor}
                        />
                    ).toBlob()
                    break;
                case 'G':
                    const resDokumen = async () => {
                        try {
                            let res = await transaksiService.getPpmDokByAjuKodeDok(datappm.nomorAju, '705')
                            if (res?.data) {
                                return res?.data?.nomor
                            } else {
                                res = await transaksiService.getPpmDokByAjuKodeDok(datappm.nomorAju, '704')
                                return res?.data?.nomor
                            }
                        } catch (error) {
                        }
                    }
                    let nomorDokBL = await resDokumen()

                    const ppmMutuAreaBaruG = await Promise.all(
                        ppmMutuArea.map(async (area) => {
                            try {
                                let resKota
                                let resPropEn
                                if (area.mutuArea === '1') {
                                    resKota = await masterService.getKotaById(area.mutuCultKota)
                                    resPropEn = await masterService.getPropinsiById(area.mutuCultProp)
                                }
                                return {
                                    ...area,
                                    uraianKota: resKota.data?.uraianKota ?? "-",
                                    uraianPropinsi: resPropEn.data?.uraianPropinsiEn ?? "-"
                                };
                            } catch (err) {
                                // console.error(err);
                                return {
                                    ...area,
                                    uraianKota: "-",
                                    uraianPropinsi: "-"
                                };
                            }
                        })
                    )
                    toBlob = await pdf(
                        <DraftG
                            datappm={datappm}
                            ppmDetil={ppmDetil}
                            ppmKontainer={ppmKontainer}
                            ppmKemasan={ppmKemasanBaru}
                            ppmMutu={ppmMutu}
                            ppmMutuArea={ppmMutuAreaBaruG}
                            ppmMutuProd={ppmMutuProd}
                            dataHc={dataHc}
                            upt={upt}
                            negaraTujuan={negaraTujuan}
                            pelMuat={pelMuat}
                            pelBongkar={pelBongkar}
                            totalJumlah={totalJumlah}
                            nomorDokumen={nomorDokBL}
                            qrImage={qrImage}
                            spesimenTtd={spesimenTtdH}
                        />
                    ).toBlob()
                    break;
                case 'NZ':
                    toBlob = await pdf(
                        <DraftNZ
                            datappm={datappm}
                            ppmDetil={ppmDetil}
                            ppmKontainer={ppmKontainer}
                            ppmKemasan={ppmKemasanBaru}
                            ppmMutu={ppmMutu}
                            dataHc={dataHc}
                            upt={upt}
                            negaraTujuan={negaraTujuan}
                            pelMuat={pelMuat}
                            qrImage={qrImage}
                            spesimenTtd={spesimenTtdH}
                        />
                    ).toBlob()
                    break;
                case 'UK':
                    toBlob = await pdf(
                        <DraftUK
                            datappm={datappm}
                            ppmDetil={ppmDetil}
                            ppmKontainer={ppmKontainer}
                            ppmKemasan={ppmKemasanBaru}
                            ppmMutu={ppmMutu}
                            ppmMutuArea={ppmMutuArea}
                            ppmMutuProd={ppmMutuProd}
                            dataHc={dataHc}
                            upt={upt}
                            negaraTujuan={negaraTujuan}
                            pelMuat={pelMuat}
                            pelBongkar={pelBongkar}
                            qrImage={qrImage}
                            spesimenTtd={spesimenTtdH}
                        />
                    ).toBlob()
                    break;
                case 'XA':
                    toBlob = await pdf(
                        <DraftXA
                            datappm={datappm}
                            ppmDetil={ppmDetil}
                            ppmKontainer={ppmKontainer}
                            ppmKemasan={ppmKemasanBaru}
                            ppmMutu={ppmMutu}
                            ppmMutuArea={ppmMutuArea}
                            dataHc={dataHc}
                            upt={upt}
                            negaraTujuan={negaraTujuan}
                            pelMuat={pelMuat}
                            pelBongkar={pelBongkar}
                            totalJumlah={totalJumlah}
                            qrImage={qrImage}
                            spesimenTtd={spesimenTtdH}
                        />
                    ).toBlob()
                    break;
                case 'XF':
                    toBlob = await pdf(
                        <DraftXF
                            datappm={datappm}
                            ppmDetil={ppmDetil}
                            ppmKontainer={ppmKontainer}
                            ppmKemasan={ppmKemasanBaru}
                            ppmMutu={ppmMutu}
                            ppmMutuArea={ppmMutuArea}
                            dataHc={dataHc}
                            upt={upt}
                            negaraTujuan={negaraTujuan}
                            pelMuat={pelMuat}
                            pelBongkar={pelBongkar}
                            totalJumlah={totalJumlah}
                            qrImage={qrImage}
                            spesimenTtd={spesimenTtdH}
                        />
                    ).toBlob()
                    break;
                default:
                    toBlob = await pdf(<DraftH datappm={datappm}
                        dataHc={dataHc}
                        ppmDetil={ppmDetil}
                        ppmKontainer={ppmKontainer}
                        ppmKemasan={ppmKemasanBaru}
                        ppmMutu={ppmMutu}
                        ppmMutuArea={ppmMutuArea}
                        ppmMutuProd={ppmMutuProd}
                        upt={upt}
                        negaraTujuan={negaraTujuan}
                        pelMuat={pelMuat}
                        pelBongkar={pelBongkar}
                        qrImage={qrImage}
                        spesimenTtd={spesimenTtdH}
                        finalFor={finalFor}
                    />).toBlob()
                    break;
            }
        }
    } catch (error) {
        console.log(error)
    }

    return toBlob
}
